import React from 'react';
import PropTypes from 'prop-types';
import { StarIcon } from '../../../../components/ui/icons';
import i18n from '../../../../shared/util/i18n';
import styles from './RatingRow.module.css';

export default function RatingRow({ value = 0 }) {
  if (!value) return null;

  const formatted = value.toFixed(1).replace('.', ',');

  return (
    <div className={styles.root}>
      <span className={styles.label}>{i18n.t('AVALIATIONS')}:</span>
      <StarIcon value={value} />
      <span className={styles.value}>{formatted}</span>
    </div>
  );
}

RatingRow.propTypes = {
  value: PropTypes.number
};
